import "../../App.css";

const CustomInput = ({
    type = "text",
    id = "",
    value = "",
    placeholder = "Enter sample",
    onChange = () => { },
    className,
    isError = false,
    required = false,
    errorMsg = "Internal server error",
    style = {}
}) => {

    return (
        <>
            <input
                id={id}
                className={className}
                type={type}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                required={required}
                style={{ ...style }}
            />
            {
                isError &&
                <p className="mb-6" style={{ color: "red" }}>{errorMsg}</p>
            }
        </>
    );
};

export default CustomInput;